import {CellId, PersistedGridState, Size} from './types';

const VALID_SIZES: Size[] = ['coarse', 'medium', 'fine'];

function storageKey(projectId: string, featureId: number): string {
  return `lens.grid.v1.${projectId}.${featureId}`;
}

export function readGridState(
  projectId: string,
  featureId: number | null
): PersistedGridState | null {
  if (featureId === null) return null;
  try {
    const raw = localStorage.getItem(storageKey(projectId, featureId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const gridSizeValid = parsed.gridSize === null || VALID_SIZES.includes(parsed.gridSize);
    if (!gridSizeValid || !Array.isArray(parsed.reviewedCellIds)) {
      return null;
    }
    return {
      gridSize: parsed.gridSize,
      reviewedCellIds: parsed.reviewedCellIds,
    };
  } catch {
    return null;
  }
}

export function writeGridState(
  projectId: string,
  featureId: number | null,
  state: Omit<PersistedGridState, 'reviewedCellIds'> & {reviewedCellIds: Set<CellId>}
): void {
  if (featureId === null) return;
  try {
    localStorage.setItem(
      storageKey(projectId, featureId),
      JSON.stringify({...state, reviewedCellIds: Array.from(state.reviewedCellIds)})
    );
  } catch {
    // thought about throwing a toast here but this gets called anytime grid
    // state changes and might get annoying if a user is trying to flag cells
    // reviewed but localStorage is blocked for some reason, so silently fail
    return;
  }
}

export function clearGridState(projectId: string, featureId: number | null): void {
  if (featureId === null) return;
  try {
    localStorage.removeItem(storageKey(projectId, featureId));
  } catch {
    return;
  }
}
